import { LaLigaTracking } from '@laliga-cdac/react';
import { toast } from 'react-toastify';
import history from './history';

const Tracking = new LaLigaTracking({
  instrumentationKey: process.env.REACT_APP_INSIGHTS_KEY,
  history,
  toast,
});

export default Tracking;
